// PublicRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";

interface PublicRouteProps {
    children: React.ReactNode;
}

const AuthPublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
    // Vérifier si l'utilisateur est déjà connecté
    const token = localStorage.getItem("token_customer_silverjarz");
    
    // Si l'utilisateur est connecté, rediriger vers le dashboard
    if (token) {
        return <Navigate to="/my-dashboard" replace />;
    }

    // Sinon, afficher la page publique (login)
    return <>{children}</>;
};

export default AuthPublicRoute;